import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";

import { CancelButton, SaveButton } from "../../../common/Button";
// import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Col, Container, Row, Form, InputGroup } from "react-bootstrap";
import {
  VehicleCategory,
  AllCity,
} from "../../../../utils/apis/masters/masters";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
library.add(fas);
const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("name", data.name);
      DataToSend.append("image", data?.image[0]);
      const response = await postData(`/masters/save-as/${id}`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/masters/save-as/${id}`);
    reset(response?.data);

    setImagePreview(IMG_URL + response?.data?.image);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [charCount, setCharCount] = useState(0);
  const maxCharLimit = 100;

  const handleInputChange = (e) => {
    setCharCount(e.target.value.length);
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Edit User Help Type</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Container fluid>
            <Row>
              {/* Right side - Form */}
              <Col md={12}>
                <Card className="shadow-lg p-3 mb-5 bg-white rounded">
                  <Card.Body>
                    <Card.Title>Edit Save As </Card.Title>
                    <hr />
                    <Container>
                      <Row>
                        {/* Editing fields */}
                        <Col md={8}>
                          <Form
                            onSubmit={() => handleSubmit(onSubmit)}
                            role="form"
                          >
                            {" "}
                            <Row>
                              <Col md={6}>
                                <div className="main-form-section mt-3">
                                  <Row className="justify-content-center">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Group>
                                      <InputGroup>
                                        <Form.Control
                                          type="text"
                                          name="name"
                                          placeholder="State"
                                          className={classNames("", {
                                            "is-invalid": errors?.name,
                                          })}
                                          {...register("name", {
                                            required: "Name is required",
                                            maxLength: {
                                              value: maxCharLimit,
                                              message: `Name cannot exceed ${maxCharLimit} characters`,
                                            },
                                          })}
                                          maxLength={maxCharLimit}
                                          onChange={handleInputChange}
                                        />
                                      </InputGroup>
                                      <div className="text-end">
                                        <small>
                                          {maxCharLimit} characters Limit{" "}
                                        </small>
                                      </div>

                                      {errors.name && (
                                        <span className="text-danger">
                                          {errors.name.message}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </Row>
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="main-form-section mt-3">
                                  <Form.Group>
                                    <div className="text-center">
                                      <Form.Label>Image</Form.Label>
                                    </div>
                                    <InputGroup>
                                      <Form.Control
                                        type="file"
                                        name="image"
                                        placeholder="Image"
                                        className={classNames("", {
                                          "is-invalid": errors?.image,
                                        })}
                                        {...register("image")}
                                        accept="image/*"
                                        onChange={handleImageChange}
                                      />
                                    </InputGroup>
                                    {errors.name && (
                                      <span className="text-danger">
                                        {errors.image.message}
                                      </span>
                                    )}
                                  </Form.Group>
                                  {imagePreview && (
                                    <div className="mt-2">
                                      <img
                                        src={imagePreview}
                                        alt="Category Preview"
                                        style={{ maxWidth: "100px" }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </Col>
                            </Row>
                            <Row className="mt-5 pb-3">
                              <div className="d-flex justify-content-center">
                                <Link>
                                  <CancelButton
                                    name={"cancel"}
                                    handleClose={props.handleClose}
                                  />
                                </Link>
                                <SaveButton
                                  name={"save"}
                                  handleSubmit={handleSubmit(onSubmit)}
                                />
                              </div>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};
export default EditOffCanvance;
